const isDev = process.env.NODE_ENV === 'development'
const fakePlayerError = false // To set to true for testing (Enabled only in dev mode)
const fakePlayerErrorCode = 'PLAYER_ENTITLEMENT_NO_DRM_FOUND'

const env = Object.freeze({
    fakePurchases: false,
    fakePlayerError: false,
    fakePlayerErrorCode,
    // To activate to simulate an entitlement status change (not needed to be activated for dev)
    fakeCheckEntitlementToggle: false,
    disableYellowBox: false,
    // display Admin Screen only if the env is not production
    displayAdminScreen: false,
    debug: {
        touchable: false,
    },
})

export default env
